/* eslint-disable import/prefer-default-export */
export const ADD_TEAM_MEMBER_TABS_DATA = ['crtMmbStep1', 'crtMmbStep2'];
